import { SET_SELECTED_SCHOOL_INDEX } from '../actions';

export default function selectedSchoolIndexReducer(state = 918, action) {
    switch(action.type) {
        case SET_SELECTED_SCHOOL_INDEX:
            return action.schoolIndex;
        default:
            return state;
    }
}